'use strict'
module.exports = window.FormData
